import React, { useState } from 'react'
import Web3 from 'web3'
import { useWallet } from 'use-wallet'

import Button from 'components/Button'
import Modal from 'components/Modal'
import ModalActions from 'components/ModalActions'
import ModalTitle from 'components/ModalTitle'
import InputArea from 'components/InputArea'
import { toast } from 'react-toastify'

import { updatePoolIntroById } from 'api'


const EditPoolIntrolModal = ({ onDismiss, title, poolId, setPoolIntro }) => {
  const { ethereum, account } = useWallet()

  const [introContent, setIntroContent] = useState(title)
  const [loading, setLoading] = useState(false)

  const onIntroContentChange = (e) => {
    setIntroContent(e.target.value)
  }

  const updatePoolIntro = async () => {
    setLoading(true)
    const web3 = new Web3(ethereum)
    const signature = await web3.eth.personal.sign(introContent, account, '',)
    const payload = {
      data: introContent,
      signature
    }
    updatePoolIntroById(poolId, payload)
    .then((res) => {
      if (res?.result) {
        setPoolIntro(payload.data)
        toast('Pool Intro Updated Successfully')
        onDismiss()
      }
    })
    .catch((err) => {
      console.log('err: ', err)
    })
    .finally(() => {setLoading(false)})
  }

  return (
    <Modal>
      <ModalTitle text="Update Pool Intro" />
      <div style={{ width: '100%', textAlign: 'center', paddingBottom: 10 }}>
        We support <a href="https://guides.github.com/features/mastering-markdown/" target="_blank">markdowns</a>
      </div>
      
      <InputArea 
        value={introContent}
        onChange={onIntroContentChange}
      />
      <ModalActions>
        <Button
          text="Change intro"
          variant="secondary"
          disabled={loading}
          onClick={updatePoolIntro}
        />
      </ModalActions>
    </Modal>
  )
}

export default EditPoolIntrolModal
